// extracted by mini-css-extract-plugin
export default {"page":"SYbpH","select":"fLTe6","selectTitle":"BWc8p"};